import { StyleSheet } from 'react-native'
import STYLES from '../../constants/styles'

export default StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject
        , backgroundColor: STYLES.BACKGROUND_COLOR
        , flexDirection: 'column'
        , justifyContent: 'center'
        , alignItems: 'center'
        , padding: 20
    },
    avatar: {
        flex: 1
        , justifyContent: 'center'
        , alignItems: 'center'
        , alignSelf: 'flex-start'
    },
    identity: {
        flexDirection: 'row'
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    badgeStyle: {
        borderRadius: 10
        , marginRight: 15
    },
    badgeImageStyle: {
        borderRadius: 10
        , borderWidth: 4
        , borderColor: 'white'
        , width: 40
        , height: 40
    },
    username: {
        fontSize: 24
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    street: {
        fontSize: 12
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    cardStyle: {
        flex: 6
        , justifyContent: 'center'
        , alignItems: 'center'
        , alignSelf: 'stretch'
    },
    datePicker: {
        flex: 1
        , flexDirection: 'row'
        , justifyContent: 'center'
        , alignItems: 'center'
        , alignSelf: 'stretch'
    },
    datePickerText: {
        fontSize: 16
        , fontWeight: 'bold'
        , color: STYLES.PRIMARY_TEXT_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/containers/dashboard/styles.js